// projects/humanresources-personnel/src/assets/i18n/*/hr-per-type-edu-subtype.json
export class HrPerTypeEduSubtypeKey {
    private static readonly keyPrefix = 'hrPerTypeEduSubtype';
    public static title = `${HrPerTypeEduSubtypeKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerTypeEduSubtypeKey.keyPrefix}.pageHeader`;
    public static educationSubtypeCode = `${HrPerTypeEduSubtypeKey.keyPrefix}.educationSubtypeCode`;
}
